export default __webpack_public_path__ + "static/media/bihada-factory-mission-02.8eed2047.jpg";